module.exports = __webpack_public_path__ + "static/media/shape_scarlet.75fe7c8a.svg";